"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
function default_1(plotLines, colors) {
    var options = [];
    options = plotLines.map(function (plotLine, i) {
        var props = plotLine.props;
        var color = utils_1.parseColor(props.color, colors[i]);
        var width = props.width || 2;
        return __assign(__assign({}, props), { color: color, width: width });
    });
    return options;
}
exports.default = default_1;
//# sourceMappingURL=plotLineOptions.js.map